import { render, staticRenderFns } from "./SideMenuLayout.vue?vue&type=template&id=54467378"
import script from "./SideMenuLayout.vue?vue&type=script&lang=js"
export * from "./SideMenuLayout.vue?vue&type=script&lang=js"
import style0 from "./SideMenuLayout.vue?vue&type=style&index=0&id=54467378&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports